import React from "react";

import "./spinner.scss";

const Spinner = () => <div className="loader" />;

export default Spinner;
